import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/about-2.jpg" className="img-responsive" alt=""
                 style={{"boxShadow": "rgba(0, 0, 0, 0.5) 0px 5px 15px"}}/>{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>About Us</h2>
              <p>Manny's has been around for more than 40 years, serving the local community with great haircuts. Our
                shop is dedicated to its friendly environment and high-quality cuts!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
